export enum ESupportedLanguages {
  English = "en",
}
